import React, { useEffect, useState } from "react";
import { getLanguage } from "react-switch-lang";
import { useDispatch, useSelector } from "react-redux";
import { selectEventCategories } from "../store/categorySlice";
import { BASE_URL } from "../constant";
import { Link } from "react-router-dom";
import { setHasEvents } from "../store/checkoutSlice";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { routes } from "../routes.constants";

export default function EventTable({
  eventItems = [],
  setEventItems,
  onDataChange,
}) {
  const dispatch = useDispatch();
  const eventCategories = useSelector(selectEventCategories);
  const [updatingMachineTests, setUpdatingMachineTests] = useState(new Map());

  useEffect(() => {
    // TODO: This isn't working with eventItems change, maybe change was not a deep copy...
    updateCheckoutSteps();
  }, [eventItems]);

  // const [removeKey, setRemoveKey] = useState("0");

  function updateCheckoutSteps(externalEventItems = null) {
    const _events = externalEventItems ?? eventItems;
    if (_events.length > 0) {
      dispatch(setHasEvents(true));
    } else {
      dispatch(setHasEvents(false));
    }
  }

  async function handleQuantityChange({ event_type_id, event_id, schedule_id, change, currentParent, currentChild }) {
    const user_id = localStorage.getItem("user_id");
    
    try {
      if (user_id && user_id > 0) {
        
        
        if (+event_type_id === 3) {
          // Prevent concurrent quantity updates for the same machine test and operation
          const operationKey = `${event_id}_${change > 0 ? 'plus' : 'minus'}`;
          if (updatingMachineTests.has(operationKey)) {
            return;
          }
          
          // Add this operation to the updating map
          setUpdatingMachineTests(prev => new Map(prev).set(operationKey, true));

          const currentTotal = (currentParent || 0) + (currentChild || 0);
          if (change < 0 && currentTotal <= 0) {
            setUpdatingMachineTests(prev => {
              const newMap = new Map(prev);
              newMap.delete(operationKey);
              return newMap;
            });
            return;
          }

          const updateUrl = `${BASE_URL}cart/addMachineTestEventToCart/${event_id}/${user_id}/${change}/0`;
          const updateReqData = await (await fetch(updateUrl, { method: 'GET' })).json();
          
          if (updateReqData.status === 'true') {
            // Refresh cart data
            const machineEventListUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/${getLanguage()}`;
            const machineEventReqData = await (await fetch(machineEventListUrl)).json();
            
            const eventListUrl = `${BASE_URL}cart/getAllMyCartDataForEvents/${user_id}/${getLanguage()}`;
            const eventReqData = await (await fetch(eventListUrl)).json();
            
            setEventItems([...eventReqData, ...machineEventReqData]);
            
            toast("Quantity updated successfully", {
              containerId: "B",
              type: toast.TYPE.SUCCESS,
            });
            onDataChange();
            
            setUpdatingMachineTests(prev => {
              const newMap = new Map(prev);
              newMap.delete(operationKey);
              return newMap;
            });
          } else {
            toast("Failed to update quantity", {
              containerId: "B",
              type: toast.TYPE.ERROR,
            });
            
            setUpdatingMachineTests(prev => {
              const newMap = new Map(prev);
              newMap.delete(operationKey);
              return newMap;
            });
          }
        } else {
          
          toast("Quantity update for events not yet implemented", {
            containerId: "B",
            type: toast.TYPE.INFO,
          });
        }
      } else {
        
        if (+event_type_id === 3) {
          // Prevent concurrent quantity updates for the same machine test and operation
          const operationKey = `${event_id}_${change > 0 ? 'plus' : 'minus'}`;
          if (updatingMachineTests.has(operationKey)) {
            return;
          }
          
          // Add this operation to the updating map
          setUpdatingMachineTests(prev => new Map(prev).set(operationKey, true));

          
          let guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
          const itemIndex = guestMachineTests.findIndex(item => item.event_id == event_id);
          
          if (itemIndex !== -1) {
            const currentParentCount = parseInt(guestMachineTests[itemIndex].parent || 0, 10);
            const currentChildCount = parseInt(guestMachineTests[itemIndex].child || 0, 10);
            const currentTotal = currentParentCount + currentChildCount;
            if (change < 0 && currentTotal <= 0) {
              setUpdatingMachineTests(prev => {
                const newMap = new Map(prev);
                newMap.delete(operationKey);
                return newMap;
              });
              return;
            }

            const newParent = Math.max(0, currentParentCount + change);
            const newTotal = newParent + currentChildCount;
            if (newTotal <= 0) {
              guestMachineTests.splice(itemIndex, 1);
            } else {
              guestMachineTests[itemIndex].parent = newParent;
            }
            
            localStorage.setItem('guest_mt_cart', JSON.stringify(guestMachineTests));
            
            // Refresh display
            let guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
            const transformedEvents = transformGuestEventsForDisplay(guestEvents);
            if (guestMachineTests.length > 0) {
              transformedEvents.push({
                event_type: 'Machine Test',
                event_type_id: 3,
                arr_cart: guestMachineTests.map(mt => ({
                  event_id: mt.event_id,
                  schedule_id: mt.schedule_id,
                  title: mt.title,
                  parent: mt.parent || 0,
                  child: mt.child || 0,
                  first_price: mt.price || mt.first_price || 0,
                  second_price: mt.child_price || mt.second_price || mt.price || 0,
                  venue_address: mt.venue_address || ''
                }))
              });
            }
            setEventItems(transformedEvents);
            
            toast("Quantity updated successfully", {
              containerId: "B",
              type: toast.TYPE.SUCCESS,
            });
            onDataChange();
            
            setUpdatingMachineTests(prev => {
              const newMap = new Map(prev);
              newMap.delete(operationKey);
              return newMap;
            });
          }
        } else {
          // Regular event guest - for future implementation if needed
          toast("Quantity update for events not yet implemented", {
            containerId: "B",
            type: toast.TYPE.INFO,
          });
        }
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
      toast("Failed to update quantity", {
        containerId: "B",
        type: toast.TYPE.ERROR,
      });
      const operationKey = `${event_id}_${change > 0 ? 'plus' : 'minus'}`;
      setUpdatingMachineTests(prev => {
        const newMap = new Map(prev);
        newMap.delete(operationKey);
        return newMap;
      });
    }
  }

  async function handleRemoveEvent({ event_type_id, event_id, schedule_id }) {
    // Only treat as logged in if user_id is a valid positive integer
    let user_id = localStorage.getItem("user_id");
    if (!user_id || isNaN(Number(user_id)) || Number(user_id) <= 0) user_id = null;

    let are_you_sure = "Are you sure?";
    let revert = "Do you want to remove the item from the cart ?";
    let deleteConfirm = "Yes, delete it!";
    let cancel = "Cancel";
    if (getLanguage() == "ma") {
      are_you_sure = "तुम्हाला खात्री आहे?";
      revert = "आपण कार्टमधून वस्तू/उपक्रम काढून टाकू इच्छिता ?";
      deleteConfirm = "होय, काढून टाका";
      cancel = "नाही";
    }

    try {
      const result = await Swal.fire({
        title: are_you_sure,
        text: revert,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: cancel,
        confirmButtonText: deleteConfirm,
      });

      if (!result.value) return null;

      if (user_id && user_id > 0) {
        // Logged-in user: use API
        let removeUrl;
        if (+event_type_id === 3) {
          // Machine test - use event_id
          removeUrl = `${BASE_URL}cart/removeProductFromCart/${event_id}/${user_id}`;
        } else {
          // Regular event - use schedule_id
          removeUrl = `${BASE_URL}cart/removeProductFromCart/${schedule_id}/${user_id}`;
        }
        
        const removeReqData = await (await fetch(removeUrl)).json();
        if (removeReqData?.status) {
          toast("" + removeReqData?.message, {
            containerId: "B",
            type: toast.TYPE.SUCCESS,
          });
          
          // Refetch all cart data from backend
          const eventListUrl = `${BASE_URL}cart/getAllMyCartDataForEvents/${user_id}/${getLanguage()}`;
          const eventReqData = await (await fetch(eventListUrl)).json();
          const machineEventListUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/${getLanguage()}`;
          const machineEventReqData = await (await fetch(machineEventListUrl)).json();
          
          const combined = [...eventReqData, ...machineEventReqData];
          setEventItems(combined);
          updateCheckoutSteps(combined);
          onDataChange();
        } else {
          toast("Failed to remove item", {
            containerId: "B",
            type: toast.TYPE.ERROR,
          });
        }
      } else {
        // Guest user: remove from localStorage
        if (+event_type_id === 3) {
          // Remove from guest_mt_cart (machine tests)
          let guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
          if (schedule_id) {
            guestMachineTests = guestMachineTests.filter(item => !(item.event_id == event_id && item.schedule_id == schedule_id));
          } else {
            guestMachineTests = guestMachineTests.filter(item => item.event_id != event_id);
          }
          localStorage.setItem('guest_mt_cart', JSON.stringify(guestMachineTests));
          // Update eventItems for display
          let guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
          const transformedEvents = transformGuestEventsForDisplay(guestEvents);
          // Add machine tests as a separate group if any remain
          if (guestMachineTests.length > 0) {
            transformedEvents.push({
              event_type: 'Machine Test',
              event_type_id: 3,
              arr_cart: guestMachineTests.map(mt => ({
                event_id: mt.event_id,
                schedule_id: mt.schedule_id,
                title: mt.title,
                parent: mt.parent || 0,
                child: mt.child || 0,
                first_price: mt.price || 0,
                second_price: mt.child_price || mt.price || 0,
                venue_address: mt.venue_address || ''
              }))
            });
          }
          setEventItems(transformedEvents);
          toast("Machine test removed from cart", {
            containerId: "B",
            type: toast.TYPE.SUCCESS,
          });
          updateCheckoutSteps(transformedEvents);
          onDataChange();
        } else {
          // Remove from guest_cart_events (regular events)
          let guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
          if (schedule_id) {
            guestEvents = guestEvents.filter(item => !(item.event_id == event_id && item.schedule_id == schedule_id));
          } else {
            guestEvents = guestEvents.filter(item => item.event_id != event_id);
          }
          localStorage.setItem('guest_cart_events', JSON.stringify(guestEvents));
          // Transform guest cart to match expected structure
          const transformedEvents = transformGuestEventsForDisplay(guestEvents);
          // Also add any remaining machine tests
          let guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
          if (guestMachineTests.length > 0) {
            transformedEvents.push({
              event_type: 'Machine Test',
              event_type_id: 3,
              arr_cart: guestMachineTests.map(mt => ({
                event_id: mt.event_id,
                schedule_id: mt.schedule_id,
                title: mt.title,
                parent: mt.parent || 0,
                child: mt.child || 0,
                first_price: mt.price || 0,
                second_price: mt.child_price || mt.price || 0,
                venue_address: mt.venue_address || ''
              }))
            });
          }
          setEventItems(transformedEvents);
          toast("Event removed from cart", {
            containerId: "B",
            type: toast.TYPE.SUCCESS,
          });
          updateCheckoutSteps(transformedEvents);
          onDataChange();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  // Helper function to transform guest events to match backend structure
  function transformGuestEventsForDisplay(guestEvents) {
    if (!guestEvents || guestEvents.length === 0) return [];
    
    // Group events by event_type for display
    const groupedEvents = {};
    guestEvents.forEach(event => {
      const eventType = event.event_type || 'Event';
      if (!groupedEvents[eventType]) {
        groupedEvents[eventType] = {
          event_type: eventType,
          event_type_id: event.event_type_id || 1,
          arr_cart: []
        };
      }
      groupedEvents[eventType].arr_cart.push({
        event_id: event.event_id,
        schedule_id: event.schedule_id,
        title: event.title,
        parent: event.parent || 0,
        child: event.child || 0,
        first_price: event.price || 0,
        second_price: event.child_price || event.price || 0,
        venue_address: event.venue_address || '',
      });
    });
    
    return Object.values(groupedEvents);
  }

  return (
    <>
      {eventItems?.length > 0 && (
        <>
          <div className="card rounded-lg mb-2">
            <h4 className="d-block d-md-none card-header">
              <strong>Machine Test Details</strong>
            </h4>
            <div class="d-none d-md-block text-white rounded-top bg-accent">
              <div className="row no-gutters align-items-end m-3">
                <div className="col-6 h6 mb-1">MACHINE TEST DETAILS</div>
                <div className="col-2 text-center">
                  <small>PARTICIPANTS</small>
                </div>
                <div className="col-3 text-center">
                  <small>AMOUNT</small>
                </div>
                <div className="col-1 p-0"></div>
              </div>
            </div>
            <div className="overflow-hidden">
              {eventItems.map((evs) => (
                <>
                  <div>
                    {evs?.arr_cart.map((ev) => (
                      <>
                        <div className="row no-gutters border-bottom p-3">
                          <div className="col-12 col-md-6 mb-1">
                            <h5>{ev?.title}</h5>
                            <small className="d-block">
                              <strong>{ev?.venue_address}</strong>
                            </small>
                            <small className="d-block mt-2 fst-italic">
                              <b>{evs?.event_type}</b>
                            </small>
                          </div>
                          <div className="col-4 col-md-2 d-flex justify-content-center align-items-center">
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                handleQuantityChange({
                                  event_type_id: evs?.event_type_id,
                                  event_id: ev?.event_id,
                                  schedule_id: ev?.schedule_id,
                                  change: -1,
                                  currentParent: +ev?.parent,
                                  currentChild: +ev?.child
                                });
                              }}
                              disabled={(+ev?.parent + +ev?.child) <= 0 || (evs?.event_type_id === 3 && updatingMachineTests.has(`${ev?.event_id}_minus`))}
                            >
                              <i className="fas fa-minus"></i>
                            </button>
                            <span className="m-1 d-inline border rounded form-control text-monospace text-center">
                              {+ev?.parent + +ev?.child}
                            </span>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                handleQuantityChange({
                                  event_type_id: evs?.event_type_id,
                                  event_id: ev?.event_id,
                                  schedule_id: ev?.schedule_id,
                                  change: 1,
                                  currentParent: +ev?.parent,
                                  currentChild: +ev?.child
                                });
                              }}
                              disabled={evs?.event_type_id === 3 && updatingMachineTests.has(`${ev?.event_id}_plus`)}
                            >
                              <i className="fas fa-plus"></i>
                            </button>
                          </div>
                          <div className="col-6 col-md-3 d-flex justify-content-center align-items-center">
                            <h5>
                              <strong>
                                ₹{" "}
                                {+(ev?.first_price * ev?.parent) +
                                  +(ev?.second_price * ev?.child)}
                              </strong>
                            </h5>
                          </div>
                          <div className="col-2 order-4 col-md-1 d-flex justify-content-center align-items-center">
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                console.log(
                                  ev?.event_id,
                                  ev?.schedule_id,
                                  evs?.event_type_id
                                );

                                handleRemoveEvent({
                                  event_type_id: evs?.event_type_id,
                                  event_id: ev?.event_id,
                                  schedule_id: ev?.schedule_id,
                                });
                              }}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="add-more-div mb-4">
            {(() => {
              const hasMachineTests = (eventItems || []).some(e => +e.event_type_id === 3 || (e.event_type && e.event_type.toLowerCase().includes('machine')));
              if (hasMachineTests) {
                const path = `/booknow/${encodeURIComponent('Machine Tests')}/3`;
                return (
                  <Link to={path} className="btn btn-outline-success w-100">
                    <i className="fas fa-plus me-4"></i>
                    <span className="ms-4 ml-4">Add More Machine Tests</span>
                  </Link>
                );
              }

              // Fallback: if no machine tests, show generic Events link
              return (
                <Link
                  to={routes.eventsCalendar}
                  className="btn btn-outline-success w-100"
                >
                  <i className="fas fa-plus me-4"></i>
                  <span className="ms-4 ml-4">Add More Events</span>
                </Link>
              );
            })()}
          </div>
        </>
      )}
    </>
  );
}
